import { BASE_PATH as i, BaseAPI as S, operationServerMap as C } from "../base.js";
import { DUMMY_BASE_URL as I, assertParamExists as y, createRequestFunction as P, serializeDataIfNeeded as O, setSearchParams as g, toPathString as p } from "../common.js";
import v from "axios";
var M = function(r) {
  return {
    merchantPmsItemCategoryCreateCategory: async (s, a = {}) => {
      y("merchantPmsItemCategoryCreateCategory", "merchantPmsItemCategory", s);
      const m = new URL("/merchant/pms/item/category", I);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...a
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", g(m, n);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...c,
        ...a.headers
      }, e.data = O(s, e, r), {
        url: p(m),
        options: e
      };
    },
    merchantPmsItemCategoryDeleteCategory: async (s, a = {}) => {
      y("merchantPmsItemCategoryDeleteCategory", "merchantPmsCategoryId", s);
      const m = "/merchant/pms/item/category/{merchantPmsCategoryId}".replace("{merchantPmsCategoryId}", encodeURIComponent(String(s))), t = new URL(m, I);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "DELETE",
        ...e,
        ...a
      }, n = {};
      g(t, {});
      let c = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: p(t),
        options: o
      };
    },
    merchantPmsItemCategoryGetCategory: async (s, a = {}) => {
      y("merchantPmsItemCategoryGetCategory", "shopId", s);
      const m = "/merchant/pms/item/category/{shopId}".replace("{shopId}", encodeURIComponent(String(s))), t = new URL(m, I);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, n = {};
      g(t, {});
      let c = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: p(t),
        options: o
      };
    },
    merchantPmsItemCategoryGetCategoryAndProductList: async (s, a = {}) => {
      y("merchantPmsItemCategoryGetCategoryAndProductList", "shopId", s);
      const m = "/merchant/pms/item/category/list_by_shop_id/{shopId}".replace("{shopId}", encodeURIComponent(String(s))), t = new URL(m, I);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, n = {};
      g(t, {});
      let c = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: p(t),
        options: o
      };
    },
    merchantPmsItemCategoryGetCategoryTree: async (s, a = {}) => {
      y("merchantPmsItemCategoryGetCategoryTree", "shopId", s);
      const m = "/merchant/pms/item/category/tree/{shopId}".replace("{shopId}", encodeURIComponent(String(s))), t = new URL(m, I);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, n = {};
      g(t, {});
      let c = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: p(t),
        options: o
      };
    },
    merchantPmsItemCategoryGetCategoryTreeWithProducts: async (s, a = {}) => {
      y("merchantPmsItemCategoryGetCategoryTreeWithProducts", "shopId", s);
      const m = "/merchant/pms/item/category/tree_with_products/{shopId}".replace("{shopId}", encodeURIComponent(String(s))), t = new URL(m, I);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, n = {};
      g(t, {});
      let c = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: p(t),
        options: o
      };
    },
    merchantPmsItemCategoryGetItemList: async (s, a, m, t = {}) => {
      y("merchantPmsItemCategoryGetItemList", "merchantPmsCategoryId", s);
      const e = "/merchant/pms/item/category/itemList/{merchantPmsCategoryId}".replace("{merchantPmsCategoryId}", encodeURIComponent(String(s))), o = new URL(e, I);
      let n;
      r && (n = r.baseOptions);
      const c = {
        method: "GET",
        ...n,
        ...t
      }, l = {}, h = {};
      a !== void 0 && (h.page = a), m !== void 0 && (h.size = m), g(o, h);
      let u = n && n.headers ? n.headers : {};
      return c.headers = {
        ...l,
        ...u,
        ...t.headers
      }, {
        url: p(o),
        options: c
      };
    },
    merchantPmsItemCategoryGetItemListWithoutPage: async (s, a = {}) => {
      y("merchantPmsItemCategoryGetItemListWithoutPage", "merchantPmsCategoryId", s);
      const m = "/merchant/pms/item/category/item_list/{merchantPmsCategoryId}".replace("{merchantPmsCategoryId}", encodeURIComponent(String(s))), t = new URL(m, I);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, n = {};
      g(t, {});
      let c = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: p(t),
        options: o
      };
    },
    merchantPmsItemCategoryGetPmsItemExtraStockInfo: async (s = {}) => {
      const a = new URL("/merchant/pms/item/category/stock/extra", I);
      let m;
      r && (m = r.baseOptions);
      const t = {
        method: "GET",
        ...m,
        ...s
      }, e = {};
      g(a, {});
      let o = m && m.headers ? m.headers : {};
      return t.headers = {
        ...e,
        ...o,
        ...s.headers
      }, {
        url: p(a),
        options: t
      };
    },
    merchantPmsItemCategoryMove: async (s, a, m = {}) => {
      y("merchantPmsItemCategoryMove", "merchantPmsCategoryId", s), y("merchantPmsItemCategoryMove", "direction", a);
      const t = new URL("/merchant/pms/item/category/move", I);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "PATCH",
        ...e,
        ...m
      }, n = {}, c = {};
      s !== void 0 && (c.merchantPmsCategoryId = s), a !== void 0 && (c.direction = a), g(t, c);
      let l = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...l,
        ...m.headers
      }, {
        url: p(t),
        options: o
      };
    },
    merchantPmsItemCategoryMoveCategory: async (s, a = {}) => {
      y("merchantPmsItemCategoryMoveCategory", "productMoveCategoryVO", s);
      const m = new URL("/merchant/pms/item/category/move", I);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...a
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", g(m, n);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...c,
        ...a.headers
      }, e.data = O(s, e, r), {
        url: p(m),
        options: e
      };
    },
    merchantPmsItemCategorySearchItemList: async (s, a = {}) => {
      y("merchantPmsItemCategorySearchItemList", "productSearchVO", s);
      const m = new URL("/merchant/pms/item/category/item_list/search", I);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...a
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", g(m, n);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...c,
        ...a.headers
      }, e.data = O(s, e, r), {
        url: p(m),
        options: e
      };
    },
    merchantPmsItemCategorySetCategoryDisplayStatus: async (s, a, m = {}) => {
      y("merchantPmsItemCategorySetCategoryDisplayStatus", "categoryId", s), y("merchantPmsItemCategorySetCategoryDisplayStatus", "isShopDisplay", a);
      const t = new URL("/merchant/pms/item/category/display", I);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "PATCH",
        ...e,
        ...m
      }, n = {}, c = {};
      s !== void 0 && (c.categoryId = s), a !== void 0 && (c.isShopDisplay = a), g(t, c);
      let l = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...l,
        ...m.headers
      }, {
        url: p(t),
        options: o
      };
    },
    merchantPmsItemCategoryUpdateCategory: async (s, a = {}) => {
      y("merchantPmsItemCategoryUpdateCategory", "merchantPmsItemCategory", s);
      const m = new URL("/merchant/pms/item/category", I);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "PUT",
        ...t,
        ...a
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", g(m, n);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...c,
        ...a.headers
      }, e.data = O(s, e, r), {
        url: p(m),
        options: e
      };
    }
  };
}, d = function(r) {
  const s = M(r);
  return {
    async merchantPmsItemCategoryCreateCategory(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryCreateCategory(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryCreateCategory"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategoryDeleteCategory(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryDeleteCategory(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryDeleteCategory"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategoryGetCategory(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryGetCategory(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryGetCategory"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategoryGetCategoryAndProductList(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryGetCategoryAndProductList(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryGetCategoryAndProductList"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategoryGetCategoryTree(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryGetCategoryTree(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryGetCategoryTree"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategoryGetCategoryTreeWithProducts(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryGetCategoryTreeWithProducts(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryGetCategoryTreeWithProducts"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategoryGetItemList(a, m, t, e) {
      var o, n;
      const c = await s.merchantPmsItemCategoryGetItemList(a, m, t, e), l = (o = r == null ? void 0 : r.serverIndex) !== null && o !== void 0 ? o : 0, h = (n = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryGetItemList"]) === null || n === void 0 || (n = n[l]) === null || n === void 0 ? void 0 : n.url;
      return (u, V) => P(c, v, i, r)(u, h || V);
    },
    async merchantPmsItemCategoryGetItemListWithoutPage(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryGetItemListWithoutPage(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryGetItemListWithoutPage"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategoryGetPmsItemExtraStockInfo(a) {
      var m, t;
      const e = await s.merchantPmsItemCategoryGetPmsItemExtraStockInfo(a), o = (m = r == null ? void 0 : r.serverIndex) !== null && m !== void 0 ? m : 0, n = (t = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryGetPmsItemExtraStockInfo"]) === null || t === void 0 || (t = t[o]) === null || t === void 0 ? void 0 : t.url;
      return (c, l) => P(e, v, i, r)(c, n || l);
    },
    async merchantPmsItemCategoryMove(a, m, t) {
      var e, o;
      const n = await s.merchantPmsItemCategoryMove(a, m, t), c = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, l = (o = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryMove"]) === null || o === void 0 || (o = o[c]) === null || o === void 0 ? void 0 : o.url;
      return (h, u) => P(n, v, i, r)(h, l || u);
    },
    async merchantPmsItemCategoryMoveCategory(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryMoveCategory(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryMoveCategory"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategorySearchItemList(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategorySearchItemList(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategorySearchItemList"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    },
    async merchantPmsItemCategorySetCategoryDisplayStatus(a, m, t) {
      var e, o;
      const n = await s.merchantPmsItemCategorySetCategoryDisplayStatus(a, m, t), c = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, l = (o = C["MerchantPmsItemCategoryApi.merchantPmsItemCategorySetCategoryDisplayStatus"]) === null || o === void 0 || (o = o[c]) === null || o === void 0 ? void 0 : o.url;
      return (h, u) => P(n, v, i, r)(h, l || u);
    },
    async merchantPmsItemCategoryUpdateCategory(a, m) {
      var t, e;
      const o = await s.merchantPmsItemCategoryUpdateCategory(a, m), n = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = C["MerchantPmsItemCategoryApi.merchantPmsItemCategoryUpdateCategory"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (l, h) => P(o, v, i, r)(l, c || h);
    }
  };
}, L = function(r, s, a) {
  const m = d(r);
  return {
    merchantPmsItemCategoryCreateCategory(t, e) {
      return m.merchantPmsItemCategoryCreateCategory(t.merchantPmsItemCategory, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryDeleteCategory(t, e) {
      return m.merchantPmsItemCategoryDeleteCategory(t.merchantPmsCategoryId, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryGetCategory(t, e) {
      return m.merchantPmsItemCategoryGetCategory(t.shopId, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryGetCategoryAndProductList(t, e) {
      return m.merchantPmsItemCategoryGetCategoryAndProductList(t.shopId, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryGetCategoryTree(t, e) {
      return m.merchantPmsItemCategoryGetCategoryTree(t.shopId, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryGetCategoryTreeWithProducts(t, e) {
      return m.merchantPmsItemCategoryGetCategoryTreeWithProducts(t.shopId, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryGetItemList(t, e) {
      return m.merchantPmsItemCategoryGetItemList(t.merchantPmsCategoryId, t.page, t.size, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryGetItemListWithoutPage(t, e) {
      return m.merchantPmsItemCategoryGetItemListWithoutPage(t.merchantPmsCategoryId, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryGetPmsItemExtraStockInfo(t) {
      return m.merchantPmsItemCategoryGetPmsItemExtraStockInfo(t).then((e) => e(a, s));
    },
    merchantPmsItemCategoryMove(t, e) {
      return m.merchantPmsItemCategoryMove(t.merchantPmsCategoryId, t.direction, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryMoveCategory(t, e) {
      return m.merchantPmsItemCategoryMoveCategory(t.productMoveCategoryVO, e).then((o) => o(a, s));
    },
    merchantPmsItemCategorySearchItemList(t, e) {
      return m.merchantPmsItemCategorySearchItemList(t.productSearchVO, e).then((o) => o(a, s));
    },
    merchantPmsItemCategorySetCategoryDisplayStatus(t, e) {
      return m.merchantPmsItemCategorySetCategoryDisplayStatus(t.categoryId, t.isShopDisplay, e).then((o) => o(a, s));
    },
    merchantPmsItemCategoryUpdateCategory(t, e) {
      return m.merchantPmsItemCategoryUpdateCategory(t.merchantPmsItemCategory, e).then((o) => o(a, s));
    }
  };
}, U = class extends S {
  merchantPmsItemCategoryCreateCategory(r, s) {
    return d(this.configuration).merchantPmsItemCategoryCreateCategory(r.merchantPmsItemCategory, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryDeleteCategory(r, s) {
    return d(this.configuration).merchantPmsItemCategoryDeleteCategory(r.merchantPmsCategoryId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryGetCategory(r, s) {
    return d(this.configuration).merchantPmsItemCategoryGetCategory(r.shopId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryGetCategoryAndProductList(r, s) {
    return d(this.configuration).merchantPmsItemCategoryGetCategoryAndProductList(r.shopId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryGetCategoryTree(r, s) {
    return d(this.configuration).merchantPmsItemCategoryGetCategoryTree(r.shopId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryGetCategoryTreeWithProducts(r, s) {
    return d(this.configuration).merchantPmsItemCategoryGetCategoryTreeWithProducts(r.shopId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryGetItemList(r, s) {
    return d(this.configuration).merchantPmsItemCategoryGetItemList(r.merchantPmsCategoryId, r.page, r.size, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryGetItemListWithoutPage(r, s) {
    return d(this.configuration).merchantPmsItemCategoryGetItemListWithoutPage(r.merchantPmsCategoryId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryGetPmsItemExtraStockInfo(r) {
    return d(this.configuration).merchantPmsItemCategoryGetPmsItemExtraStockInfo(r).then((s) => s(this.axios, this.basePath));
  }
  merchantPmsItemCategoryMove(r, s) {
    return d(this.configuration).merchantPmsItemCategoryMove(r.merchantPmsCategoryId, r.direction, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryMoveCategory(r, s) {
    return d(this.configuration).merchantPmsItemCategoryMoveCategory(r.productMoveCategoryVO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategorySearchItemList(r, s) {
    return d(this.configuration).merchantPmsItemCategorySearchItemList(r.productSearchVO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategorySetCategoryDisplayStatus(r, s) {
    return d(this.configuration).merchantPmsItemCategorySetCategoryDisplayStatus(r.categoryId, r.isShopDisplay, s).then((a) => a(this.axios, this.basePath));
  }
  merchantPmsItemCategoryUpdateCategory(r, s) {
    return d(this.configuration).merchantPmsItemCategoryUpdateCategory(r.merchantPmsItemCategory, s).then((a) => a(this.axios, this.basePath));
  }
};
export {
  U as MerchantPmsItemCategoryApi,
  M as MerchantPmsItemCategoryApiAxiosParamCreator,
  L as MerchantPmsItemCategoryApiFactory,
  d as MerchantPmsItemCategoryApiFp
};

//# sourceMappingURL=merchant-pms-item-category-api.js.map